import { render, staticRenderFns } from "./VideoSideNav.vue?vue&type=template&id=2b47b7ca&scoped=true&"
import script from "./VideoSideNav.vue?vue&type=script&lang=js&"
export * from "./VideoSideNav.vue?vue&type=script&lang=js&"
import style0 from "./VideoSideNav.vue?vue&type=style&index=0&id=2b47b7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47b7ca",
  null
  
)

export default component.exports